import { ACTIONS } from "../../enums/Enums";

export class CachingFilter {
    static cacheWhitelist = [
        ACTIONS.GetCollections,
        ACTIONS.GetExamples,
        ACTIONS.GetProposition,
        ACTIONS.GetSearchWords,
        ACTIONS.GetConjunction,
        ACTIONS.getSuggestions,
        ACTIONS.Translate,
    ];

    static isActionCacheable(action: string): boolean {
        return this.cacheWhitelist.includes(action);
    }

    static isValidResponse(response: any): boolean {
        // Implement logic to check if the response is valid
        // For example, check if response data exists or has no error
        return response && response.data && !response.error;
    }
}
